// Password Requirements
const passwordStatus = (password) => {
  let minLength = 6; // Minimum length requirement
  let uppercaseRegex = /[A-Z]/; // At least one uppercase letter
  let lowercaseRegex = /[a-z]/; // At least one lowercase letter
  let digitRegex = /[0-9]/; // At least one digit
  let specialCharRegex = /[^A-Za-z0-9]/; // At least one special character

  if (password.length < minLength) return `Password must be at least ${minLength} characters long.`;
  if (!uppercaseRegex.test(password)) return "Password must contain at least one uppercase letter.";
  if (!lowercaseRegex.test(password)) return "Password must contain at least one lowercase letter.";
  if (!digitRegex.test(password)) return "Password must contain at least one digit.";
  if (!specialCharRegex.test(password)) return "Password must contain at least one special character.";

  // return true;
}

// Check for Password Strength
const checkPasswordStrength = (password) => {
  let strength = 1;

  if (password.length >= 6) strength += 1; // Check length
  if (password.length >= 8) strength += 1; // Check length greater than 8
  if (/[A-Z]/.test(password)) strength += 1; // Check for uppercase letters
  if (/[a-z]/.test(password)) strength += 1; // Check for lowercase letters
  if (/\d/.test(password)) strength += 1; // Check for numbers
  if (/[^A-Za-z0-9]/.test(password)) strength += 1; // Check for special characters

  return strength;
}

const isNotEmpty= (inputValue) => {
  let inputResult = inputValue.toLowerCase().trim().replace(/\s/g, '');
  return inputResult;
}

export { 
passwordStatus,
checkPasswordStrength,
isNotEmpty
};